import { render, staticRenderFns } from "./Rl3.vue?vue&type=template&id=2a8967be&"
import script from "./Rl3.vue?vue&type=script&lang=js&"
export * from "./Rl3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports